import { render } from "./PlaceAdvert.vue?vue&type=template&id=6bfd8f7d&scoped=true"
import script from "./PlaceAdvert.vue?vue&type=script&lang=js"
export * from "./PlaceAdvert.vue?vue&type=script&lang=js"

import "@/assets/css/dashStyle.css?vue&type=style&index=0&id=6bfd8f7d&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6bfd8f7d"]])

export default __exports__